import { FeatureCheckerService, PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '@shared/common/session/app-session.service';

import { Injectable } from '@angular/core';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';

@Injectable()
export class AppNavigationService {
    constructor(
        private _permissionCheckerService: PermissionCheckerService,
        private _appSessionService: AppSessionService,
        private featureChecker: FeatureCheckerService
    ) { }

    getMenu(): AppMenu {
        return new AppMenu('MainMenu', 'MainMenu', [
            new AppMenuItem(
                'Dashboard',
                'Pages.Administration.Host.Dashboard',
                'flaticon-line-graph',
                '/app/admin/hostDashboard',
            ),
            new AppMenuItem('Dashboard', 'Pages.Tenant.Dashboard', 'flaticon-line-graph', '/app/main/dashboard'),
            new AppMenuItem(
                'Saas',
                '',
                'flaticon-users',
                '',
                [],
                [
                    new AppMenuItem('Tenants', 'Pages.Tenants', 'flaticon-list-3', '/app/admin/tenants'),
                    new AppMenuItem('Editions', 'Pages.Editions', 'flaticon-app', '/app/admin/editions'),
                ],
            ),
            new AppMenuItem(
                'Master',
                '',
                'fa fa-indent',
                '',
                [],
                [
                    new AppMenuItem('Companies', 'Pages.Companies', 'fa fa-building', '/app/master/companies'),
                    new AppMenuItem('Locations', 'Pages.Locations', 'fa fa-location-arrow', '/app/master/locations'),
                    new AppMenuItem('PaymentTerms', 'Pages.PaymentTerms', 'fa fa-sitemap', '/app/master/paymentTerms'),
                    new AppMenuItem(
                        'PaymentTypes',
                        'Pages.PaymentTypes',
                        'fa fa-credit-card',
                        '/app/master/paymentTypes',
                    ),
                    new AppMenuItem('Currencies', 'Pages.Currencies', 'fa fa-dollar', '/app/master/currencies'),
                    new AppMenuItem('Taxes', 'Pages.Taxes', 'fa fa-calculator', '/app/master/taxes'),
                ],
            ),
            new AppMenuItem(
                'Inventory',
                '',
                'fa fa-filter',
                '',
                [],
                [
                    new AppMenuItem('Products', 'Pages.Products', 'fas fa-tag', '/app/inventory/products'),

                    new AppMenuItem('Departments', 'Pages.Departments', 'fa fa-building', '/app/inventory/departments'),
                    new AppMenuItem('Categories', 'Pages.Categories', 'fa fa-list-alt', '/app/inventory/categories'),
                    new AppMenuItem(
                        'SubCategories',
                        'Pages.SubCategories',
                        'fa fa-list-alt',
                        '/app/inventory/subCategories',
                    ),
                    new AppMenuItem('Units', 'Pages.Units', 'fa fa-balance-scale', '/app/inventory/units'),
                    new AppMenuItem('Brands', 'Pages.Brands', 'fa fa-crown', '/app/inventory/brands'),
                    new AppMenuItem('PriceGroups', 'Pages.PriceGroups', 'fa fa-dollar', '/app/inventory/priceGroups'),
                    new AppMenuItem(
                        'Reports',
                        '',
                        'fa fa-bars',
                        '',
                        [],
                        [
                            new AppMenuItem('Inventory Stock', 'Pages.Products', 'fa fa-file-text', '/app/inventory/inventory-stock'),
                            new AppMenuItem('Inventory Stock By Date', 'Pages.Products', 'fa fa-file-text', '/app/inventory/inventory-stock-by-date'),
                            new AppMenuItem('Department Stock', 'Pages.Products', 'fa fa-file-text', '/app/inventory/department-stock'),
                            new AppMenuItem('Inventory Movement', 'Pages.Products', 'fa fa-file-text', '/app/inventory/inventory-movement'),
                            new AppMenuItem('Average Cost Movement', 'Pages.Products', 'fa fa-file-text', '/app/inventory/average-cost-movement'),
                        ],
                    ),
                ],
            ),
            new AppMenuItem(
                'Purchase',
                '',
                'fa fa-adjust',
                '',
                [],
                [
                    new AppMenuItem('Vendors', 'Pages.Vendors', 'fa fa-users', '/app/purchase/vendors'),
                    new AppMenuItem('PurchaseOrders', 'Pages.PurchaseOrders', 'fas fa-shopping-basket', '/app/purchase/purchaseOrders'),
                    new AppMenuItem('PurchaseInvoices', 'Pages.PurchaseInvoice', 'fas fa-shopping-basket', '/app/purchase/purchaseInvoices'),
                    new AppMenuItem('PurchaseReturns', 'Pages.PurchaseReturn', 'fas fa-shopping-basket', '/app/purchase/purchaseReturns'),
                    new AppMenuItem('VendorPayments', 'Pages.VendorPayments', 'flaticon-more', '/app/purchase/vendorPayments'),
                    new AppMenuItem(
                        'Reports',
                        '',
                        'fa fa-bars',
                        '',
                        [],
                        [
                            new AppMenuItem('Daily Purchase', '', 'fa fa-file-text', '/app/purchase/daily-purchase'),
                            new AppMenuItem('Purchase Detail', '', 'fa fa-file-text', '/app/purchase/purchase-detail'),
                            new AppMenuItem('Vendor Purchase', '', 'fa fa-file-text', '/app/purchase/vendor-purchase'),
                            new AppMenuItem('Department Purchase', '', 'fa fa-file-text', '/app/purchase/department-purchase'),
                            new AppMenuItem('Item Purchase', '', 'fa fa-file-text', '/app/purchase/item-purchase'),
                            new AppMenuItem('Aged Payables', '', 'fa fa-file-text', '/app/purchase/aged-payable'),
                            new AppMenuItem('Aged Payables Details', '', 'fa fa-file-text', '/app/purchase/aged-payable-details'),
                            new AppMenuItem('Vendor Statements', '', 'fa fa-file-text', '/app/purchase/vendor-statement'),
                        ],

                    ),
                ],
                undefined,
                undefined, () => this.featureChecker.isEnabled('App.Hafsi.Purchase.TenantPurchase')),
            new AppMenuItem(
                'Sales',
                '',
                'fa fa-pencil-square',
                '',
                [],
                [


                    new AppMenuItem('Customers', 'Pages.Customers', 'fa fa-users', '/app/sales/customers'),
                    new AppMenuItem('Salespersons', 'Pages.Salespersons', 'fa fa-crown', '/app/sales/salespersons'),
                    new AppMenuItem('SalesOrders', 'Pages.SalesOrders', 'fas fa-shopping-basket', '/app/sales/salesOrders'),
                    new AppMenuItem('SalesInvoices', 'Pages.SalesInvoice', 'fas fa-shopping-basket', '/app/sales/salesInvoices'),
                    new AppMenuItem('SalesReturns', 'Pages.SalesReturn', 'fas fa-shopping-basket', '/app/sales/salesReturns'),
                    new AppMenuItem('CustomerPayments', 'Pages.CustomerPayments', 'flaticon-more', '/app/sales/customerPayments'),
                    new AppMenuItem(
                        'Reports',
                        '',
                        'fa fa-bars',
                        '',
                        [],
                        [
                            new AppMenuItem('Sales Order', '', 'fa fa-bars', '', [],
                                [
                                    new AppMenuItem('Sales Order Summary', '', 'fa fa-file-text', '/app/sales/daily-sales-order'),
                                    new AppMenuItem('Daily Sales Order Detail', '', 'fa fa-file-text', '/app/sales/daily-sales-order-detail'),
                                    new AppMenuItem('Sales Order Detail', '', 'fa fa-file-text', '/app/sales/sales-order-detail')
                                ]),
                            new AppMenuItem('Delivery Order', '', 'fa fa-bars', '', [],
                                [
                                    new AppMenuItem('Delivery Order Summary', '', 'fa fa-file-text', '/app/sales/daily-delivery-order'),
                                    new AppMenuItem('Daily Delivery Order Detail', '', 'fa fa-file-text', '/app/sales/daily-delivery-order-detail'),
                                    new AppMenuItem('Delivery Order Detail', '', 'fa fa-file-text', '/app/sales/delivery-order-detail')
                                ]),
                            new AppMenuItem('Sales Summary', '', 'fa fa-file-text', '/app/sales/daily-sales-detail'),
                            new AppMenuItem('Daily Sales By Customer', '', 'fa fa-file-text', '/app/sales/customer-sales-summary'),
                            new AppMenuItem('Daily Sales Detail', '', 'fa fa-file-text', '/app/sales/sales-detail'),
                            new AppMenuItem('Sales Detail', '', 'fa fa-file-text', '/app/sales/sales-detail'),
                            new AppMenuItem('Customer Rebate', '', 'fa fa-file-text', '/app/sales/sales-rebate'),
                            new AppMenuItem('Daily Sales Return Summary Report', '', 'fa fa-file-text', '/app/sales/daily-sales-retunr-detail'),
                            new AppMenuItem('Sales Return Detail', '', 'fa fa-file-text', '/app/sales/sales-return-detail'),
                            new AppMenuItem('Customer Sales', '', 'fa fa-file-text', '/app/sales/customer-sales-summary'),
                            new AppMenuItem('Customer Sales Analysis', '', 'fa fa-file-text', '/app/sales/customer-sales-analysis'),
                            new AppMenuItem('Customer Sales Analysis By Location', '', 'fa fa-file-text', '/app/sales/customer-sales-analysis-by-location'),
                            new AppMenuItem('Salesman Sales', '', 'fa fa-file-text', '/app/sales/salesman-sales-summary'),
                            new AppMenuItem('Sales Person Analysis', '', 'fa fa-file-text', '/app/sales/salesman-analysis'),
                            new AppMenuItem('Daily Sales By Salesman', '', 'fa fa-file-text', '/app/sales/salesman-analysis'),
                            new AppMenuItem('Department Sales', '', 'fa fa-file-text', '/app/sales/department-sales-summary'),
                            new AppMenuItem('Item Sales', '', 'fa fa-file-text', '/app/sales/item-sales-summary'),
                            new AppMenuItem('Item Sales By Customer', '', 'fa fa-file-text', '/app/sales/item-sales-summary-by-customer'),
                            new AppMenuItem('Item Profit', '', 'fa fa-file-text', '/app/sales/sales-product-analysis'),
                            new AppMenuItem('Payment Summary', '', 'fa fa-file-text', '/app/sales/payment-summary'),
                            new AppMenuItem('Payment Detail', '', 'fa fa-file-text', '/app/sales/payment-detail'),
                            new AppMenuItem('Outstanding Statements', '', 'fa fa-file-text', '/app/sales/sales-outstanding-invoices'),
                            new AppMenuItem('Account Statements', '', 'fa fa-file-text', '/app/sales/sales-account-activity'),
                            new AppMenuItem('Aged Receivables', '', 'fa fa-file-text', '/app/sales/sales-aged-receivables'),
                            new AppMenuItem('Aged Receivables Details', '', 'fa fa-file-text', '/app/sales/sales-aged-receivables-details'),
                        ],
                    ),
                ],
                undefined,
                undefined, () => this.featureChecker.isEnabled('App.Hafsi.Sales.TenantSales')),
            new AppMenuItem(
                'Stock',
                '',
                'fa fa-pencil-square',
                '',
                [],
                [
                    new AppMenuItem('StockAdjustmentTypes', 'Pages.StockAdjustmentTypes', 'fa fa-users', '/app/stock/stockAdjustmentTypes'),
                    new AppMenuItem('AddStock', 'Pages.AddStock', 'fa fa-users', '/app/stock/addStocks'),
                    new AppMenuItem('StockAdjustments', 'Pages.Adjustment', 'fa fa-users', '/app/stock/stockAdjustments'),
                    new AppMenuItem('StockTransfer', 'Pages.StockTransfer', 'fa fa-users', '/app/stock/stocktransfer'),
                    new AppMenuItem('StockReceive', 'Pages.StockReceive', 'fa fa-users', '/app/stock/stockreceive'),
                    new AppMenuItem('StockTakes', 'Pages.StockTake', 'fa fa-users', '/app/stock/stocktakes'),
                    new AppMenuItem('Productions', 'Pages.Production', 'fa fa-users', '/app/stock/productions'),
                    /*new AppMenuItem('SalesOrders', 'Pages.SalesOrders', 'fas fa-shopping-basket', '/app/sales/salesOrders'),*/

                    new AppMenuItem(
                        'Reports',
                        '',
                        'fa fa-bars',
                        '',
                        [],
                        [

                        ],
                    ),
                ],
                undefined,
                undefined, () => this.featureChecker.isEnabled('App.Hafsi.Stock.TenantAccount')),
            new AppMenuItem(
                'Account',
                '',
                'fa fa-book',
                '',
                [],
                [
                    new AppMenuItem(
                        'ChartOfAccounts',
                        'Pages.ChartOfAccounts',
                        'fa fa-line-chart',
                        '/app/account/chartOfAccounts',
                    ),
                    new AppMenuItem('AccountGroups', 'Pages.AccountGroups', 'fa fa-user', '/app/account/accountGroups'),
                    new AppMenuItem(
                        'AccountSubGroups',
                        'Pages.AccountSubGroups',
                        'fa fa-users',
                        '/app/account/accountSubGroups',
                    ),
                    new AppMenuItem(
                        'JournalVouchers',
                        'Pages.JournalVoucher',
                        'fa fa-line-chart',
                        '/app/account/journalVouchers',
                    ),
                    new AppMenuItem(
                        'PostedJournalVouchers',
                        'Pages.PostedJournalVoucher',
                        'fa fa-line-chart',
                        '/app/account/postedjournalVouchers',
                    ),
                    new AppMenuItem(
                        'Purchase',
                        '',
                        'flaticon-alarm',
                        '',
                        [],
                        [
                            new AppMenuItem('Invoices', 'Pages.PurchaseNotes', 'flaticon-mail-1', '/app/account/purchaseNotes/invoices/1',),
                            new AppMenuItem(
                                'CreditNotes',
                                'Pages.PurchaseNotes',
                                'flaticon-paper-plane',
                                '/app/account/purchaseNotes/creditNotes/2',
                            ),
                            new AppMenuItem(
                                'PaymentToOthers',
                                'Pages.PurchaseNotes',
                                'flaticon-paper-plane',
                                '/app/account/purchaseNotes/paymentToOthers/3',
                            ),
                        ],
                    ),
                    new AppMenuItem(
                        'Sales',
                        '',
                        'flaticon-alarm',
                        '',
                        [],
                        [
                            new AppMenuItem('Invoices', 'Pages.SalesNotes', 'flaticon-mail-1', '/app/account/salesNotes/invoices/1',),
                            new AppMenuItem(
                                'CreditNotes',
                                'Pages.SalesNotes',
                                'flaticon-paper-plane',
                                '/app/account/salesNotes/creditNotes/2',
                            ),
                            new AppMenuItem(
                                'ReceiptFromOthers',
                                'Pages.SalesNotes',
                                'flaticon-paper-plane',
                                '/app/account/salesNotes/receiptfromothers/3',
                            ),
                        ],
                    ),
                    new AppMenuItem(
                        'Reports',
                        '',
                        'flaticon-alarm',
                        '',
                        [],
                        [
                            new AppMenuItem('General Ledger', '', 'flaticon-mail-1', '/app/account/general-ledger'),
                            new AppMenuItem('Profit And Loss', '', 'flaticon-mail-1', '/app/account/profit-and-loss'),
                            new AppMenuItem('Balance Sheet', '', 'flaticon-mail-1', '/app/account/balance-sheet'),
                            new AppMenuItem('Trial Balance', '', 'flaticon-mail-1', '/app/account/trial-balance'),
                        ],
                    ),

                ],
                undefined,
                undefined, () => this.featureChecker.isEnabled('App.Hafsi.Account.TenantAccount')),
            new AppMenuItem(
                'Administration',
                '',
                'flaticon-interface-8',
                '',
                [],
                [
                    //new AppMenuItem(
                    //    'OrganizationUnits',
                    //    'Pages.Administration.OrganizationUnits',
                    //    'flaticon-map',
                    //    '/app/admin/organization-units',
                    //),
                    new AppMenuItem('Roles', 'Pages.Administration.Roles', 'flaticon-suitcase', '/app/admin/roles'),
                    new AppMenuItem('Users', 'Pages.Administration.Users', 'flaticon-users', '/app/admin/users'),
                    new AppMenuItem(
                        'Languages',
                        'Pages.Administration.Languages',
                        'flaticon-tabs',
                        '/app/admin/languages',
                        ['/app/admin/languages/{name}/texts'],
                    ),
                    new AppMenuItem(
                        'AuditLogs',
                        'Pages.Administration.AuditLogs',
                        'flaticon-folder-1',
                        '/app/admin/auditLogs',
                    ),
                    //new AppMenuItem(
                     //   'Maintenance',
                      //  'Pages.Administration.Host.Maintenance',
                       // 'flaticon-lock',
                        //'/app/admin/maintenance',
                    //),
                    //new AppMenuItem(
                      //  'Subscription',
                       // 'Pages.Administration.Tenant.SubscriptionManagement',
                        //'flaticon-refresh',
                        //'/app/admin/subscription-management',
                    //),
                    //new AppMenuItem(
                      //  'WebhookSubscriptions',
                       // 'Pages.Administration.WebhookSubscription',
                        //'flaticon2-world',
                        //'/app/admin/webhook-subscriptions',
                    //),
                    //new AppMenuItem(
                      //  'DynamicProperties',
                       // 'Pages.Administration.DynamicProperties',
                       // 'flaticon-interface-8',
                       // '/app/admin/dynamic-property',
                    //),
                    //new AppMenuItem(
                    //    'Notifications',
                    //    '',
                    //    'flaticon-alarm',
                    //    '',
                    //    [],
                    //    [
                    //        new AppMenuItem('Inbox', '', 'flaticon-mail-1', '/app/notifications'),
                    //        new AppMenuItem(
                    //            'MassNotifications',
                    //            'Pages.Administration.MassNotification',
                     //           'flaticon-paper-plane',
                     //           '/app/admin/mass-notifications',
                     //       ),
                     //   ],
                    //),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.Host.Settings',
                        'flaticon-settings',
                        '/app/admin/hostSettings',
                    ),
                    new AppMenuItem(
                        'Settings',
                        'Pages.Administration.Tenant.Settings',
                        'flaticon-settings',
                        '/app/admin/tenantSettings',
                    ),
                    new AppMenuItem(
                        'VisualSettings',
                        'Pages.Administration.UiCustomization',
                        'flaticon-medical',
                        '/app/admin/ui-customization',
                    ),
                ],
            ),
            //new AppMenuItem(
            //    'DemoUiComponents',
            //    'Pages.DemoUiComponents',
            //     'flaticon-shapes',
            //     '/app/admin/demo-ui-components',
            //),
        ]);
    }

    checkChildMenuItemPermission(menuItem): boolean {
        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName === '' || subMenuItem.permissionName === null) {
                if (subMenuItem.route) {
                    return true;
                }
            } else if (this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
                if (!subMenuItem.hasFeatureDependency()) {
                    return true;
                }

                if (subMenuItem.featureDependencySatisfied()) {
                    return true;
                }
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                let isAnyChildItemActive = this.checkChildMenuItemPermission(subMenuItem);
                if (isAnyChildItemActive) {
                    return true;
                }
            }
        }

        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (
            menuItem.permissionName === 'Pages.Administration.Tenant.SubscriptionManagement' &&
            this._appSessionService.tenant &&
            !this._appSessionService.tenant.edition
        ) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach((menuItem) => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach((subMenu) => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });

        return menuItems;
    }
}
